<template>
	<div class="comp">
		<el-dialog :visible.sync="dialogState" width="1380px" top="50px">
			<div style="display: flex;font-size: 18px;padding-bottom:10px;padding-left:10px;">
				<span style="padding-right: 80px;">会员名称：
					<span style="font-weight:bold" v-if="userInfo.basic_info">{{userInfo.basic_info.nick_name}}</span>
				</span>
				<span style="padding-right: 80px;">账户余额：
					<span style="font-weight:bold" v-if="userInfo.card_info">{{userInfo.card_info.user_yue}} 元</span>	
				</span>
			</div>
			<div style="height: 650px;overflow-y: scroll;position: relative;">
				<el-table :data="orderList" style="width: 100%;min-height: 650px;" v-loading="orderList.length===0" :empty-text="'加载中...'" @selection-change="changeSelection" ref="table">
					<el-table-column type="selection" width="50" :selectable="checkedFun">
					</el-table-column>
					<el-table-column type="expand">
						<template slot-scope="props">
							<el-table :data="props.row.order_item_list" style="width: 100%;margin-bottom: 20px;" size="mini" row-key="_id" :empty-text="'无数据'">
								<el-table-column label="商品名称" min-width="250">
									<template slot-scope="goodsItem">
										{{goodsItem.row.goods_name}}
									</template>
								</el-table-column>
								<el-table-column label="商品规格" min-width="250">
									<template slot-scope="goodsItem">
										{{goodsItem.row.sku_value}}
									</template>
								</el-table-column>
								<el-table-column label="标准价" min-width="90">
									<template slot-scope="goodsItem">
										{{goodsItem.row.original_price}}
									</template>
								</el-table-column>
								<el-table-column label="活动" min-width="200">
									<template slot-scope="goodsItem">
										{{goodsItem.row.activity_info&&goodsItem.row.activity_info.name}}
									</template>
								</el-table-column>
								<el-table-column label="优惠价" min-width="100">
									<template slot-scope="goodsItem">
										{{goodsItem.row.price}}
									</template>
								</el-table-column>
								<el-table-column label="商品数量" min-width="80">
									<template slot-scope="goodsItem">
										{{goodsItem.row.num}}
										<el-tooltip
										v-if="!$public.isNull(goodsItem.row.order_item_goods_list)"
										style="margin:4px;"
										effect="dark"
										placement="top"
										>
											<div slot="content">
												<span v-for="tm in goodsItem.row.order_item_goods_list" :key="tm.custom_code+Math.random()">{{tm.custom_code}} </span>
											</div>
											<span style="cursor: pointer;color:#1890FF;">条码</span>
										</el-tooltip>
									</template>
								</el-table-column>
								<el-table-column label="小计" min-width="100">
									<template slot-scope="goodsItem">
										{{$public.cheng(goodsItem.row.price,goodsItem.row.num)}}
									</template>
								</el-table-column>
								<el-table-column label="销售人员" min-width="150">
									<template slot-scope="goodsItem">
										<span v-for="staff in goodsItem.row.sales_list" :key="staff._id" style="margin-left:2px;">{{staff.sales_name}}</span>
									</template>
								</el-table-column>
							</el-table>
						</template>
					</el-table-column>
					<el-table-column label="状态" width="100">
						<template slot-scope="props">
							{{$public.formatOrderState(props.row.state)}}
						</template>
					</el-table-column>
					<el-table-column label="创建时间" prop="goodsName">
						<template slot-scope="props">
							{{$public.FTime(props.row.create_time)}}
						</template>
					</el-table-column>
					<el-table-column label="订单号" prop="no" >
					</el-table-column>
					<el-table-column label="订单类型" prop="order_type" width="120">
					</el-table-column>
					<el-table-column label="优惠券" prop="coupon_list">
						<template slot-scope="props">
							{{$public.isNull(props.row.coupon_list) ? '' : props.row.coupon_list[0].coupon_name+'('+props.row.coupon_list[0]._no+')'}}
						</template>
					</el-table-column>
					<el-table-column label="订单总额" prop="total_price">
					</el-table-column>
				</el-table>
			</div>
			<div class="payLine">
				<div class="payLineL">
					<span class="text">
						应付金额:￥<b style="font-size: 26px;">{{total}}</b>
					</span>
				</div>
				<div class="payLineR">
					<div class="btn" style="background-color: #3BB0FE;" @click="submit">
						结算
					</div>
				</div>
			</div>
		</el-dialog>
		<!-- 结算 -->
		<div v-if="dialogSettlementState">
			<dialogSettlement :type="settlement_type" :orderId="curOrder._id||curOrder.merge_order_no" @submit="dialogSettlementSubmit"></dialogSettlement>
		</div>
	</div>
</template>
<script>
	import dialogSettlement from "./dialog_settlement.vue"
	export default {
		components:{dialogSettlement},
		data() {
			return {
				dialogState:true,
				userInfo:{},
				orderList:[],
				selection:[],
				total:0,
				
				// 结算
				dialogSettlementState:false,
				settlement_type:'order',
			}
		},
		props:{
			orderNoList:{
				default:()=>{
					return []
				}
			}
		},
		watch:{
			dialogState(n){
				this.$emit('submit',{type:'close',data:n})
			}
		},
		mounted() {
		if (this.orderNoList.length === 0) {
			this.$message({
				message: "组件内未传入订单号",
				type: "error"
			});
				return ;
			}else{
				for(let i=0;i<this.orderNoList.length;i++){
					this.getOrderDetail(this.orderNoList[i])
				}
			}
		},
		methods: {
		submit() {
			let arr = [];
			for (let i = 0; i < this.selection.length; i++) {
				arr.push(this.selection[i].no);
			}
			if (arr.length === 0) {
				this.$message({
					message: "没有要结算的订单",
					type: "error"
				});
					return ;
				}else if(arr.length===1){
					this.settlement_type = "order"
					this.curOrder = this.selection[0]
					this.dialogSettlementState = true;
				}else{
					this.settlement_type = "mergeOrder"
					let loading = this.$loading()
					this.$http.post('/api/Order/MergeOrder', arr).then(res => {
						loading.close();
						if (res.code == 0) {
							this.settlement_type = "mergeOrder"
							this.curOrder = res.data;
							this.dialogSettlementState = true;
						}
					})
				}
			},
			// 结算完成关闭弹窗
			dialogSettlementSubmit(a) {
				this.dialogSettlementState = false;
				if (a == 'close') {
					console.log(a)
				} else if (a == 'fail') {
					this.$message({
						message: '结算失败',
						type: 'error'
					});
				} else if (a == 'success') {
					this.$message({
						message: '结算成功',
						type: 'success'
					});
					this.$emit('submit',{type:'success'})
				}
			},
			changeSelection(){
				console.log('全选');
				this.getTotal()
			},
			getOrderDetail(no){
				let params = {
					orderid: no,
				}
				this.$http.get('/api/Order/GetOrder', params).then(res => {
					if (res.code == 0) {
						console.log(res,'order--------');
						this.orderList.push(res.data)
						if(this.orderList.length===this.orderNoList.length){
							this.$nextTick(()=>{
								let doubleGoodsAndLiving=0;
								for(let i=0;i<this.orderList.length;i++){
									if(this.orderList[i].order_type_id===8){
										doubleGoodsAndLiving+=2
									}else{
										doubleGoodsAndLiving+=1
									}
								}
								for(let i=0;i<this.orderList.length;i++){
									const isCheck =this.orderList[i].order_item_list.some(item => {
					                return (
						                   item.activity_info && item.activity_info.pay_type.includes("11")
					                       );
				                    })
									if((this.orderList[i].order_type_id===8&&doubleGoodsAndLiving!==this.orderList.length) || isCheck){
										console.log(this.orderList[i],false);
										this.$refs['table'].toggleRowSelection(this.orderList[i],false)
									}else{
										console.log(this.orderList[i],true);
										this.$refs['table'].toggleRowSelection(this.orderList[i],true)
									}
								}
								this.getTotal();
							})
						}
						this.getUserDetail(res.data.user_info.user_id)
					}
				})
			},
		checkedFun(row, index) {
			console.log(row, index);
			const isCheck =
				row.order_type_id !== 2 ||
				!row.order_item_list.some(item => {
					return (
						item.activity_info && item.activity_info.pay_type.includes("11")
					);
				});
			let doubleGoodsAndLiving = 0;
			for (let i = 0; i < this.orderList.length; i++) {
				if (this.orderList[i].order_type_id === 8) {
					doubleGoodsAndLiving += 2;
				} else {
					doubleGoodsAndLiving += 1;
				}
			}
			if ((row.order_type_id === 8 && doubleGoodsAndLiving !== this.orderList.length) || !isCheck ) {
        return false;
      } else {
        return true;
      }
    },
			getTotal(){
				console.log(this.$refs.table.selection,'zongdingdan');
				this.selection = this.$refs.table.selection;
				this.total = 0;
				for(let i=0;i<this.selection.length;i++){
					this.total = this.$public.jia(this.total, this.selection[i].total_price)
				}
			},
			getUserDetail(id){
				if(this.$public.isNull(this.userInfo._id)){
					this.userInfo._id = id;
					this.$util.getUserInfo(id).then(data=>{
						this.userInfo = data;
					})
				}
		}
	}
};
</script>
<style lang="scss" scoped>
	.comp {
		::v-deep .el-dialog__body{
			padding-top:10px;
		}
		.payLine{
			display: flex;
			justify-content: space-between;
			padding-top:30px;
			.payLineL{
				.text{
					font-size: 16px;
					line-height: 48px;
					margin-right: 30px;
				}
			}
			.payLineR{
				.text{
					font-size: 16px;
					margin-right: 30px;
				}
				.btn{
					display: inline-block;
					color:white;
					height: 40px;
					width:120px;
					border-radius: 4px;
					text-align: center;
					line-height: 38px;
					margin-right: 35px;
					cursor: pointer;
					.img{
						width:20px;
						height: 20px;
						margin-right: 4px;
						vertical-align: sub;
					}
				}
			}
		}
	}
</style>
